import Vue from 'vue';

const success = (response, context) => {
  if (context.registration) {
    context.next(7);
  } else {
    context.next(4);
  }
};

const failed = (error, context) => {

};

export default (context, data) => {
  Vue.$http.post('/send-sms-v2', data).then((response) => {
    if (response && response.status === 200) {
      success(response, context);
    }
  })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/sendsmsV2.js